<template>
  <div ref="adContainer" class="ad-container">
    <iframe ref="iframe" :src="adurl" frameborder="0" scrolling="no"></iframe>
  </div>
</template>

<script>
export default {
  name: 'AdContainer',
  props: {
    isShowTitle: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Number,
      default: 1
    },
    dataId: {
      default: null
    },
    dataTitle: {
      type: String,
      default: null
    },
    list: {
      type: Array,
      default: () =>{
        return []
      }
    }
  },
  computed: {
    adurl: function() {
      if(this.list.length == 0){
        return ''
      }
      return this.list[0].redirect
    }
  },
  data () {
    return {
    }
  },
  watch: {
    list() {
      this.appendScript()
    }
  },
  mounted() {
    setTimeout(()=>{
      this.initHeight()
    }, 1000)
  },
  methods: {
    initHeight(){
      const content = this.$refs.iframe.contentWindow
      const dom = content.document
      this.$refs.iframe.height = dom.body.offsetHeight
      console.log('height', dom.body.offsetHeight)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ad-container{
  padding: 6px;
}
.ad-container iframe{
  height: 88px;
  width: 100%;
}
</style>
